import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ActionSheet from '@medflex/components/stories/ActionSheet';
import { IconEditPencil, IconTrash } from '@medflex/components/stories/Icons';
import PopupMenu from '@medflex/components/stories/PopupMenu';
import ContextMenuTriggerButton from '@medflex/components/stories/ContextMenu/ContextMenuTriggerButton';
import { useTranslation } from 'react-i18next';
import useModal from '../../hooks/useModal';
import useUserProfile from '../../hooks/useUserProfile';

const StaffActionMenu = ({ contact, onClickOutside, hidden }) => {
  const wrapperRef = useRef();
  const { t } = useTranslation('messenger');
  const { userProfile } = useUserProfile();
  const { open } = useModal();
  const { isPhysician: isPractitioner } = userProfile.flags;

  const actions = [
    [
      {
        onClick: () =>
          open({ modal: 'staff_member', id: contact.user.id, subType: contact.user.type }),
        Icon: IconEditPencil,
        text: t('StaffActionMenu.actions.edit'),
      },
      {
        onClick: () =>
          open({ modal: 'delete_staff_member', id: contact.user.id, subType: contact.user.type }),
        Icon: IconTrash,
        text: t('StaffActionMenu.actions.delete'),
      },
    ],
  ];

  const handleOutsideClick = e => {
    if (wrapperRef.current) {
      if (!wrapperRef.current.contains(e.target)) {
        onClickOutside();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    isPractitioner && (
      <div data-component="StaffActionMenu" hidden={hidden} ref={wrapperRef}>
        <PopupMenu>
          <PopupMenu.Menu>
            {actions.map((groups, i) => (
              <PopupMenu.Group key={`groups#${i}`}>
                {groups.map(({ Icon, text, ...rest }) => (
                  <PopupMenu.Item {...rest} key={`action#${text}`}>
                    <Icon size="text" />
                    <div className="ml-4">{text}</div>
                  </PopupMenu.Item>
                ))}
              </PopupMenu.Group>
            ))}
          </PopupMenu.Menu>
          <PopupMenu.Trigger>
            {({ triggerRef }) => (
              <ContextMenuTriggerButton ref={triggerRef} hidden className="lg:flex" />
            )}
          </PopupMenu.Trigger>
        </PopupMenu>
        <ActionSheet initialVisible={false}>
          <ActionSheet.Menu closeButtonLabel={t('global:actions.close_button')}>
            {actions.map(groups =>
              groups.map(({ Icon, text, ...rest }) => (
                <ActionSheet.Item {...rest} key={`action#${text}`}>
                  <Icon size="text" />
                  <div className="ml-4">{text}</div>
                </ActionSheet.Item>
              )),
            )}
          </ActionSheet.Menu>
          <ActionSheet.Trigger>
            {({ triggerRef }) => (
              <ContextMenuTriggerButton ref={triggerRef} className="lg:hidden" />
            )}
          </ActionSheet.Trigger>
        </ActionSheet>
      </div>
    )
  );
};

StaffActionMenu.propTypes = {
  contact: PropTypes.shape({
    user: PropTypes.shape().isRequired,
  }),
  onClickOutside: PropTypes.func.isRequired,
  hidden: PropTypes.bool.isRequired,
};

export default StaffActionMenu;
